export default "__VITE_ASSET__DZ6BjP4A__"